/** Resolve /api/media paths to the public backend origin when the SPA is on another host. */
export function resolveMediaUrl(url) {
  if (!url) return url;
  const u = String(url).trim();
  if (!u) return u;
  if (/^https?:\/\//i.test(u) || u.startsWith('data:')) return u;
  const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  if (!base) return u.startsWith('/') ? u : `/${u}`;
  const path = u.startsWith('/') ? u : `/${u}`;
  return `${base}${path}`;
}
